module.exports = __webpack_public_path__ + "assets/体检费用补贴说明.95d45a00.pdf";